/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { resolveViteEnvSources } from './resolveViteEnvSources';

const REACT_APP_ENDPOINT_PREFIX = 'REACT_APP_ENDPOINT_';
const VITE_ENDPOINT_PREFIX = 'VITE_ENDPOINT_';

const normalizeEndpointValue = value => {
  if (typeof value !== 'string' || value.trim() === '') {
    return '';
  }

  return value.trim().replace(/\/$/, '');
};

const getEnvSources = processEnv => {
  const sources = [];

  if (processEnv && typeof processEnv === 'object') {
    sources.push(processEnv);
  }

  sources.push(...resolveViteEnvSources());

  return sources;
};

const applyPrefixOverrides = (overrides, envSources, prefix) => {
  for (const env of envSources) {
    for (const key of Object.keys(env)) {
      if (!key.startsWith(prefix)) {
        continue;
      }

      const apiName = key.slice(prefix.length).replace('__', '-');
      const value = normalizeEndpointValue(env[key]);

      if (!value || overrides[apiName] !== undefined) {
        continue;
      }

      overrides[apiName] = value;
    }
  }
};

export const endpointOverrides = (processEnv = typeof process !== 'undefined' ? process.env : {}) => {
  const overrides = {};
  const envSources = getEnvSources(processEnv);

  applyPrefixOverrides(overrides, envSources, REACT_APP_ENDPOINT_PREFIX);
  applyPrefixOverrides(overrides, envSources, VITE_ENDPOINT_PREFIX);

  return overrides;
};
